const { isObject } = require('../is-object')
const { size } = require('../size')

/**
 * @param {array|object} add
 * @returns {string|undefined}
 */
function addUrlSearchParams (add) {
  if (
    typeof window === 'undefined' ||
    !isObject(add) ||
    !size(add)
  ) return

  const url = new URL(window.location.href)

  for (const key of Object.keys(add)) {
    url.searchParams.delete(key)
    url.searchParams.append(key, add[key])
  }

  window.history.replaceState(null, null, url.search)

  return url.href
}

module.exports = { addUrlSearchParams }
